import { memo, useCallback, useState } from 'react';
import { Modal, ModalProps } from '@app/components';
import { ContactRequestsForm, ContactRequestsFormValues } from '@app/forms';
import { ReactComponent as IconCloseModal } from './close.svg';
import { createContactRequest } from '@app/api';
import { Dialog, DialogContent, DialogHeader } from 'components/ui/dialog';

interface ContactRequestsModalProps extends ModalProps {
  onClose: () => void;
  onSubmit?: () => Promise<void>;
  okedCode?: string;
  katoCode?: string;
}

function ContactRequestsModal(props: ContactRequestsModalProps) {
  const {
    visible,
    className = '',
    onClose,
    onSubmit,
    okedCode,
    katoCode,
  } = props;
  const [pending, setPending] = useState<boolean>(false);

  const handleSubmit = useCallback(
    async (data: ContactRequestsFormValues): Promise<void> => {
      return new Promise(async (resolve, reject) => {
        try {
          if (pending) {
            return;
          }
          setPending(true);
          await createContactRequest({
            phone: data.phone,
            okedCode: okedCode || null,
            katoCode: katoCode || null,
          });
          setTimeout(async () => {
            setPending(false);
            if (onSubmit) {
              await onSubmit();
            }
            onClose();
            resolve();
          }, 800);
        } catch (e) {
          setTimeout(() => {
            setPending(false);
            reject(e);
          }, 800);
        }
      });
    },
    [onClose, pending, onSubmit, okedCode, katoCode]
  );

  if (!visible) {
    return null;
  }

  return (
    <Dialog open={visible} onOpenChange={onClose}>
      <DialogContent className="max-w-md w-full">
        <div className="p-6">
          <div className="flex items-center mb-3">
            <span className="font-medium text-2xl text-[#424242]">
              Введите номер
            </span>
          </div>
          <ContactRequestsForm onSubmit={handleSubmit} pending={pending} />
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default memo(ContactRequestsModal);
